import { AdminRole } from "@repo/api-dtos"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import * as React from "react"
import { PageHeader } from "@/components/layout"
import { Skeleton } from "@/components/ui/skeleton"
import { useAdminRolesContext } from "@/contexts/admin-roles-context"
import { PricingConfigEditor } from "@/features/pricing-config/PricingConfigEditor"
import { usePricingConfig } from "@/queries/marketplace"

export const Route = createFileRoute("/configuration/pricing")({
	component: PricingConfigurationPage,
})

function PricingConfigurationPage() {
	const navigate = useNavigate()
	const { hasAnyRole, hasRole } = useAdminRolesContext()
	const canRead = hasAnyRole([
		AdminRole.Superadmin,
		AdminRole.MarketplaceOrderSupport,
	])
	const canEdit = hasRole(AdminRole.Superadmin)
	const { configVersion, isLoading, error, refetch } = usePricingConfig({
		enabled: canRead,
	})

	React.useEffect(() => {
		if (!canRead) navigate({ to: "/unauthorized" })
	}, [canRead, navigate])
	if (!canRead) return null

	const header = (
		<PageHeader
			title="Pricing"
			description="Who gets Price check and Reprice, Good deals for every condition, and the Price check email. Each save is a new version, used within a minute."
		/>
	)

	if (error || isLoading || !configVersion) {
		return (
			<div className="flex max-w-5xl flex-col gap-6 p-6">
				{header}
				{error ? (
					<p className="rounded-lg bg-bad-soft px-3 py-2 text-bad">
						Failed to load the configuration: {error.message}
					</p>
				) : (
					<div className="flex flex-col gap-3">
						<Skeleton className="h-[58px] w-full" />
						<Skeleton className="h-[58px] w-full" />
						<Skeleton className="h-[58px] w-full" />
					</div>
				)}
			</div>
		)
	}

	return (
		<PricingConfigEditor
			header={header}
			active={configVersion}
			canEdit={canEdit}
			onReload={() => refetch()}
		/>
	)
}
